import React from "react";
import { Box, Card, CardContent, Typography, Grid,IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  FaUserTie,
  FaBookOpen,
  FaStore,
  FaBus,
  FaMoneyBillWave,
  
} from "react-icons/fa";
  
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useAuth } from "../../../AuthProvider";



const PrincipalReports = () => {
  const navigate = useNavigate();
  const {feature} = useAuth();





  const reports = [
     {
    id: "01",
    title: "Admission Reports",
    color: "#E91E63",
    icon: <FaBookOpen />,
    path: "/AdmissionReportsScreen",
  },
  {
    id: "02",
    title: "HRBP Reports",
    color: "#9C27B0",
    icon: <FaUserTie />,
    path: "/HRBPReportsScreen",
  },

     ...(feature === "CORE" || feature === "ULTRA"
      ? [
         {
            id: "03",
            title: "Transport Reports",
            color: "#FF9800",
            icon: <FaBus />,
            path: "/TransportReportsScreen",
          },
          {
            id: "04",
            title: "Store Reports",
            color: "#FF5722",
            icon: <FaStore />,
            path: "/StoreReportsScreen",
          },
 
        ]
      : []), // Don't include 'Packages' if not ULTRA
  // {
  //   id: "03",
  //   title: "Transport Reports",
  //   color: "#FF9800",
  //   icon: <FaBus />,
  //   path: "/TransportReportsScreen",
  // },
 
  // {
  //   id: "04",
  //   title: "Store Reports",
  //   color: "#FF5722",
  //   icon: <FaStore />,
  //   path: "/StoreReportsScreen",
  // },
  
  {
    id: "05",
    title: "Expenses Reports",
    color: "#357FE9",
    icon: <FaMoneyBillWave />,
    path: "/ExpensesReportsScreen",
  },
];

  return (
    <Box sx={{ mt: 6, mx: 2 }}>

       {/* Header */}
            <Box display="flex" alignItems="center" sx={{ mb: 2 }}>
              <IconButton onClick={() => navigate(-1)} sx={{ color: "black", mr: 1 }}>
                <ArrowBackIcon />
              </IconButton>
              <Typography variant="h4" fontWeight="bold">
                 Principal Reports
              </Typography>
            </Box>

      {/* <Typography
            variant="h4"
            component="h3"
            sx={{ fontWeight: "bold", mb: 4, textAlign: "center" }}
          >
            Principal Reports
          </Typography> */}
      <Card
        sx={{
          borderRadius: 3,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          backgroundColor: "#fff",
          padding: 3,
           minHeight: "500px",
        display: "flex",             // Add these
    alignItems: "center",        // Center vertically
    justifyContent: "center",
        }}
      >
        <CardContent>
          {/* <Typography
            variant="h4"
            component="h3"
            sx={{ fontWeight: "bold", mb: 4, textAlign: "center" }}
          >
            Principal Reports
          </Typography> */}

          <Grid container spacing={4} justifyContent="center">
            {reports.map((report) => (
              <Grid item xs={12} sm={6} md={5} key={report.id}>
                <Card
  onClick={() => navigate(report.path)}
  sx={{
    position: "relative",
    padding: 3,
    pl: 4,
    display: "flex",
    alignItems: "center",
    gap: 2,
    borderRadius: 2,
    backgroundColor: "#f4f5f7",
    boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
    cursor: "pointer",
    transition: "0.3s",
    overflow: "visible",
    "&:hover": {
      transform: "translateY(-4px)",
    },
  }}
>
  {/* Left Accent */}
  <Box
    sx={{
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      width: "6px",
      borderTopLeftRadius: "12px",
      borderBottomLeftRadius: "12px",
      backgroundColor: report.color,
    }}
  />

  {/* Icon and Text */}
  <Box
    sx={{
      fontSize: 30,
      color: report.color,
      minWidth: 40,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    {report.icon}
  </Box>

  <Box>
    <Typography variant="h6" sx={{ fontWeight: 600 }}>
      {report.title}
    </Typography>
    <Typography variant="body2" sx={{ color: "#666" }}>
      Detailed insights on {report.title.toLowerCase()}.
    </Typography>
  </Box>
</Card>

              </Grid>
            ))}
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};

export default PrincipalReports;
